import { ModuleEntity } from '@/enums';
import { useLocation } from 'react-router-dom';
import get from 'lodash/get';
import { useMemo } from 'react';
import { useGetTenantQuery } from './useGetTenantQuery';

export const useDetectConfigByPath = () => {
  const { pathname } = useLocation();
  const { tenant } = useGetTenantQuery();

  const { dbConfig } = tenant;

  const moduleName =
    pathname
      .split('/')
      .find(
        item => !!ModuleEntity[item.toUpperCase() as keyof typeof ModuleEntity],
      ) ?? '';

  const customModuleConfiguration = useMemo(
    () => get(dbConfig, 'organization.customModuleConfiguration', undefined),
    [dbConfig],
  );

  const configModule = useMemo(
    () =>
      customModuleConfiguration?.[
        ModuleEntity[moduleName.toUpperCase() as keyof typeof ModuleEntity]
      ] ?? {},
    [customModuleConfiguration, moduleName],
  );

  return configModule;
};
